module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO50CalculadoraDePatrimoniob.50ca6a4.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO50CalculadoraDePatrimoniob.mp4
// module id = 776
// module chunks = 1